import * as React from 'react'
import cx from 'classnames'
import Checkbox from 'components/Checkbox'
import styles from './ListItem.sass'

interface ListItemProps {
  children?: React.ReactNode
  onClick?(): unknown
  disabled?: boolean
  /**
   * If true, does not round the first item.
   */
  hasListHeader?: boolean
}

export function ListItem({
  children,
  onClick,
  hasListHeader,
  disabled,
}: ListItemProps) {
  return (
    <a
      onClick={() => !disabled && onClick?.()}
      className={cx(
        styles.root,
        hasListHeader && styles.hasListHeader,
        onClick && styles.clickable,
      )}
    >
      {children}
    </a>
  )
}

interface ListItemVisualProps {
  children?: React.ReactNode
}

export function ListItemVisual({ children }: ListItemVisualProps) {
  return <div className={cx(styles.visual)}>{children}</div>
}

interface ListItemContentProps {
  children?: React.ReactNode
}

export function ListItemContent({ children }: ListItemContentProps) {
  return <div className={cx(styles.content)}>{children}</div>
}

interface ListItemTitleProps {
  children?: React.ReactNode
  title?: string
}

export function ListItemTitle({ title, children }: ListItemTitleProps) {
  return (
    <p title={title} className={cx(styles.title)}>
      {children}
    </p>
  )
}

interface ListItemDescriptionProps {
  children?: React.ReactNode
  title?: string
}

export function ListItemDescription({
  title,
  children,
}: ListItemDescriptionProps) {
  return (
    <p title={title} className={cx(styles.description)}>
      {children}
    </p>
  )
}

interface ListItemExtrasProps {
  children?: React.ReactNode
}

export function ListItemExtras({ children }: ListItemExtrasProps) {
  return <div className={cx(styles.extras)}>{children}</div>
}

interface ListItemCheckboxProps {
  checked: boolean
  disabled?: boolean
  loading?: boolean
  onChange?(checked: boolean): unknown
}

export function ListItemCheckbox({
  checked,
  loading,
  disabled,
}: ListItemCheckboxProps) {
  return <Checkbox checked={checked} loading={loading} disabled={disabled} />
}
